export const AMPLITUDE_LOCALSTORAGE_KEY = {
    ALREADY_SIGN_IN: 'alfredAlreadySignIn',
    HAS_INITIAL_CAMERA: 'hasInitialCamera',
}
